import { CdkDragDrop, CdkDragEnd, CdkDragMove, Point } from '@angular/cdk/drag-drop';
import { Component, ElementRef, EventEmitter, Inject, NO_ERRORS_SCHEMA, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { PDFDocumentProxy, PdfViewerComponent } from 'ng2-pdf-viewer';



@Component({
  selector: 'cloud-visual-signature-position',
  templateUrl: './visual-signature-position.component.html',
  styleUrls: ['./visual-signature-position.component.scss'],
  providers: [PdfViewerComponent],

})

export class VisualSignaturePositionComponent {

  @Output() close: EventEmitter<any> = new EventEmitter();
  isPdfUploaded = false;
  totalPages: number;
  currentPage = 1;
  pdfSrc = '';
  height: number;
  width: number;
  signatureWidth = 180;
  signatureHeight = 50;
  loaded = false;
  currentFileIndex: number;
  pdfLoaded = false;
  private scrollThreshold = 100; // pixels from edge that trigger scrolling (increased from 50)
  private scrollSpeed = 15; // pixels to scroll per interval (increased from 10)
  private scrollIntervalId: any = null;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService,
    public dialogRef: MatDialogRef<VisualSignaturePositionComponent>
  ) {}

  off: any;
  scaleX = 1; //relation aspect between items.width in dropZone and items.width in List
  scaleY = 1; //relation aspect between items.height in dropZone and items.height in List
  _pointerPosition;

  @ViewChild('signedList', { read: ElementRef, static: true })
  dropZone: ElementRef;

  signers = [];
  signed = [];
  onDrag: boolean = false;

  ngOnInit() {
    this.loadFile(0);
  }

  loadFile(i) {
    this.currentFileIndex = i;
    const fileURL = URL.createObjectURL(this.data.files[i].file);
    this.pdfSrc = fileURL;
    this.loadExistingSignatures()
  }

  loadExistingSignatures() {
    this.signed = [];
    this.signers = [];

    if (this.data.files[this.currentFileIndex].signaturePosition) {
      this.signed = this.data.files[this.currentFileIndex].signaturePosition;
    }
    if (this.data.webIdentificationOtc === true) {

      if (Array.isArray(this.data.signers)) {
        this.signers = [...this.data.signers];
      } else {
        console.warn('Expected signers to be array, got:', this.data.signers);
      }

      this.signers.push({
        x: 0,
        y: 0,
        width: this.signatureWidth,
        height: this.signatureHeight,
        'z-index': 0,
        page: 0
      });
    } else {
      if (Array.isArray(this.data.signers)) {
        this.data.signers.forEach(s => {
          this.signers.push({
            cmrId: s.cmrId,
            x: 0,
            y: 0,
            width: this.signatureWidth,
            height: this.signatureHeight,
            'z-index': 0,
            page: 0
          });
        });
      }
    }
  }

  saveSignatures(i) {
    this.data.files[i].signaturePosition = this.signed;
  }

  selectedDataValue(e) {
    this.saveSignatures(this.currentFileIndex);
  }

  getFileName(i) {
    return this.data.files[i].file.name;
  }

  objectComparisonFunction = function (option, value): boolean {
    return option === value;
  }

  chechSelected() {
    return true;
  }

  getLabel(item) {
    if (this.data.webIdentificationOtc === true) {
      const currentUser = this.data.signers;
      return this.translateService.currentLang === 'bg' ? currentUser.bg : currentUser.en;

    } else {
      let cmrId = item.cmrId;
      const currentUser = this.data.signers.find(u => u.cmrId === cmrId);   
      return this.translateService.currentLang === 'bg' ? currentUser.firstName.bg + ' ' + currentUser.lastName.bg :
        currentUser.firstName.en + ' ' + currentUser.lastName.en;
    }
  }

  pageEvent(pageNumber: number): void {
    this.currentPage = pageNumber;
  }

  onPdfLoad(pdf: PDFDocumentProxy) {
    this.totalPages = pdf.numPages;
    this.pdfLoaded = true;
  }

  getTotalCount() {
    return this.totalPages;
  }

  onPageLoaded(ev) {
    let el = ev.source.div.getBoundingClientRect();
    if (el.height) {
      this.height = el.height;
    }
    if (el.width) {
      this.width = el.width;
    }
    this.loaded = true;
    this.dialogRef.updateSize((this.getSize() + 'px'), '');
  }

  getSize() {
    return this.width + 2 * this.signatureWidth;
  }

  onReset() {
    this.currentFileIndex = 0;
    this.currentPage = 1;
    this.signed = [];
    this.data.files.forEach(f => {
      f.signaturePosition = null;
    })
    this.loadFile(0);
  }
  drop(event: CdkDragDrop<any[]>, isDropZone: boolean = false) {
    // Always stop auto-scroll when drop occurs
    this.stopAutoScroll();
    
    if (event.previousContainer != event.container) {
      const data = event.previousContainer.data[event.previousIndex];
      const index = event.container.data.length;

      event.item.data.y =
        this._pointerPosition.y -
        this.off.y * this.scaleY -
        this.dropZone.nativeElement.getBoundingClientRect().top;
      event.item.data.x =
        this._pointerPosition.x -
        this.off.x * this.scaleX -
        this.dropZone.nativeElement.getBoundingClientRect().left;
      this.changeZIndex(event.container.data[index]);      // Calculate target position
      const targetX = this._pointerPosition.x -
            this.off.x * this.scaleX -
            this.dropZone.nativeElement.getBoundingClientRect().left;
      const targetY = this._pointerPosition.y -
            this.off.y * this.scaleY -
            this.dropZone.nativeElement.getBoundingClientRect().top;
      
      // Check if completely out of bounds
      const completelyOut =
        targetY + this.signatureHeight < 0 ||
        targetX + this.signatureWidth < 0 ||
        targetY > this.height ||
        targetX > this.width;
        
      // Check if partially out of bounds
      const partiallyOut =
        targetY < 0 ||
        targetX < 0 ||
        targetY + this.signatureHeight > this.height ||
        targetX + this.signatureWidth > this.width;
        
      // Adjusted position for snap back
      const adjustedX = Math.min(Math.max(0, targetX), this.width - this.signatureWidth);
      const adjustedY = Math.min(Math.max(0, targetY), this.height - this.signatureHeight);

      if (!completelyOut) {
        // If not completely out, add with adjusted position
        event.container.data.push({
          cmrId: data.cmrId,
          // Use adjusted position if partially out
          x: partiallyOut ? adjustedX : targetX,
          y: partiallyOut ? adjustedY : targetY,
          width: this.signatureWidth,
          height: this.signatureHeight,
          'z-index': 0,
          'page': this.currentPage
        });
      }
    }
  } 
  
  isAlreadyAddedd(item) {
    let found = this.signed.find(i => i.cmrId === item.cmrId);
    return found;
  }
  
  moved(event: CdkDragMove) {
    this._pointerPosition = event.pointerPosition;
    const e = event.event as MouseEvent;
  
    const container = document.querySelector('mat-dialog-content');
    if (!container) return;
    
    // clear interval to avoid multiple scrolling
    if (this.scrollIntervalId) {
      clearInterval(this.scrollIntervalId);
      this.scrollIntervalId = null;
    }
  
    const containerRect = container.getBoundingClientRect();
    
    // Increase scroll threshold to make it more responsive
    const enhancedScrollThreshold = 100; // pixels from edge that trigger scrolling
      // Be very permissive with vertical bounds to improve usability
    // Don't check for viewport bounds anymore - this was making scroll too restrictive
    // Instead, we'll rely on the distance calculations to determine scrolling
    
    // Calculate distances from each edge
    const distanceFromTop = e.clientY - containerRect.top;
    const distanceFromBottom = containerRect.bottom - e.clientY;
    const distanceFromLeft = e.clientX - containerRect.left;
    const distanceFromRight = containerRect.right - e.clientX;
    
    // Calculate dynamic scroll speed based on how close to the edge
    const calculateScrollSpeed = (distance, threshold) => {
      if (distance >= threshold) return 0;
      // The closer to the edge, the faster the scroll (up to 3x the base speed)
      const speedMultiplier = Math.max(1, 3 * (1 - distance / threshold));
      return Math.ceil(this.scrollSpeed * speedMultiplier);
    };
      // Vertical scrolling (priority)
    // Increased vertical scroll threshold for better responsiveness
    const verticalScrollThreshold = 150; // pixels from edge that trigger scrolling (increased for vertical)
    
    // Check for vertical scrolling - more permissive than horizontal
    // We want to be able to scroll vertically from almost anywhere in the component
    if (distanceFromTop < verticalScrollThreshold && container.scrollTop > 0) {
      // Scroll up with dynamic speed - more aggressive for smoother experience
      const dynamicSpeed = calculateScrollSpeed(distanceFromTop, verticalScrollThreshold);
      if (dynamicSpeed > 0) {
        this.scrollIntervalId = setInterval(() => {
          container.scrollTop = Math.max(0, container.scrollTop - dynamicSpeed);
        }, 10);
      }
      return; // Prioritize vertical scrolling
    } 
    
    if (distanceFromBottom < verticalScrollThreshold && 
        container.scrollTop < (container.scrollHeight - container.clientHeight)) {
      // Scroll down with dynamic speed - more aggressive for smoother experience
      const dynamicSpeed = calculateScrollSpeed(distanceFromBottom, verticalScrollThreshold);
      if (dynamicSpeed > 0) {
        this.scrollIntervalId = setInterval(() => {
          container.scrollTop = Math.min(
            container.scrollHeight - container.clientHeight,
            container.scrollTop + dynamicSpeed
          );
        }, 10);
      }
      return; // Prioritize vertical scrolling
    }
      // Horizontal scrolling - only happens if we're not already scrolling vertically
    // Only if we're within 150px of left or right edge
    if (Math.abs(e.clientX - containerRect.left) < 150 || 
        Math.abs(e.clientX - containerRect.right) < 150) {
        
      if (distanceFromLeft < enhancedScrollThreshold && container.scrollLeft > 0) {
        // Scroll left with dynamic speed
        const dynamicSpeed = calculateScrollSpeed(distanceFromLeft, enhancedScrollThreshold);
        if (dynamicSpeed > 0) {
          this.scrollIntervalId = setInterval(() => {
            container.scrollLeft = Math.max(0, container.scrollLeft - dynamicSpeed);
          }, 10);
        }
      } else if (distanceFromRight < enhancedScrollThreshold && 
                container.scrollLeft < (container.scrollWidth - container.clientWidth)) {
        // Scroll right with dynamic speed
        const dynamicSpeed = calculateScrollSpeed(distanceFromRight, enhancedScrollThreshold);
        if (dynamicSpeed > 0) {
          this.scrollIntervalId = setInterval(() => {
            container.scrollLeft = Math.min(
              container.scrollWidth - container.clientWidth,
              container.scrollLeft + dynamicSpeed
            );
          }, 10);
        }
      }
    }
  }

  stopAutoScroll() {
    // Make sure to clear the interval if it exists
    if (this.scrollIntervalId !== null) {
      clearInterval(this.scrollIntervalId);
      this.scrollIntervalId = null;
    }
    
    // Reset any ongoing scroll behavior in the container
    const container = document.querySelector('mat-dialog-content');
    if (container) {
      // Force the browser to reevaluate the scroll positions
      container.scrollTop = container.scrollTop;
      container.scrollLeft = container.scrollLeft;
    }
  }
  changeZIndex(item: any) {
    this.signed.forEach((x) => (x['z-index'] = x == item ? 1 : 0));
  }

  changePosition(event: CdkDragDrop<any[]>, field) {
     // Always stop auto-scroll when drop occurs
    this.stopAutoScroll();
    
    const rectZone = this.dropZone.nativeElement.getBoundingClientRect();
    const rectElement =
      event.item.element.nativeElement.getBoundingClientRect();

    let y = +field.y + event.distance.y;
    let x = +field.x + event.distance.x;
    const out = y < 0 || x < 0 ||
      y > rectZone.height - rectElement.height ||
      x > rectZone.width - rectElement.width;
      
    if (!out) {
      field.y = y;
      field.x = x;
      this.signed = this.signed.sort((a, b) =>
        a['z-index'] > b['z-index'] ? 1 : a['z-index'] < b['z-index'] ? -1 : 0
      );
    }
  }

  removeSignature(item) {
    this.signed = this.signed.filter(s => s.cmrId != item.cmrId);
  }

  onSave() {
    this.saveSignatures(this.currentFileIndex);
    this.close.emit(this.data.files);
  }

  closeDialog() {
    this.close.emit(null);
  }

  snapX(item) {
    let snap = this.findClosestX(item);
    item.x = snap.x;
  }

  snapY(item) {
    let snap = this.findClosestY(item);
    item.y = snap.y;
  }

  findClosestX(item) {
    let signatures = [...this.signed];
    signatures = signatures.filter(s => s.cmrId != item.cmrId);
    let closest = signatures.reduce(function (prev, curr) {
      return ((Math.abs(curr.x - item.x) < Math.abs(prev.x - item.x) && Math.abs(curr.x - item.x) > 0) ? curr : prev);
    });
    return closest;
  }

  findClosestY(item) {
    let signatures = [...this.signed];
    signatures = signatures.filter(s => s.cmrId != item.cmrId);
    let closest = signatures.reduce(function (prev, curr) {
      return ((Math.abs(curr.y - item.y) < Math.abs(prev.y - item.y) && Math.abs(curr.y - item.y) > 0) ? curr : prev);
    });
    return closest;
  }

  hasCloseXSnap(item) {
    let found = this.signed.find(i => (Math.abs(i.x - item.x) < 20 && Math.abs(i.x - item.x) > 0));
    return found;
  }

  hasCloseYSnap(item) {
    let found = this.signed.find(i => (Math.abs(i.y - item.y) < 20 && Math.abs(i.y - item.y) > 0));
    return found;
  }

}